/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActeurMinimalDto } from './ActeurMinimalDto';
import {
    ActeurMinimalDtoFromJSON,
    ActeurMinimalDtoFromJSONTyped,
    ActeurMinimalDtoToJSON,
    ActeurMinimalDtoToJSONTyped,
} from './ActeurMinimalDto';

/**
 * Liste minimaliste d'acteurs, partagée par toutes les routes /acteurs/liste/*.
 * @export
 * @interface GetActeursResponse
 */
export interface GetActeursResponse {
    /**
     * 
     * @type {number}
     * @memberof GetActeursResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ActeurMinimalDto>}
     * @memberof GetActeursResponse
     */
    items?: Array<ActeurMinimalDto>;
}

/**
 * Check if a given object implements the GetActeursResponse interface.
 */
export function instanceOfGetActeursResponse(value: object): value is GetActeursResponse {
    return true;
}

export function GetActeursResponseFromJSON(json: any): GetActeursResponse {
    return GetActeursResponseFromJSONTyped(json, false);
}

export function GetActeursResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetActeursResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ActeurMinimalDtoFromJSON)),
    };
}

export function GetActeursResponseToJSON(json: any): GetActeursResponse {
    return GetActeursResponseToJSONTyped(json, false);
}

export function GetActeursResponseToJSONTyped(value?: GetActeursResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ActeurMinimalDtoToJSON)),
    };
}

